import { Form, Input, message, Modal } from 'antd'
import { sendResetPassword } from '../../services/forget_password'

export async function popResetPassword(): Promise<void> {
  let emailValue = ''

  Modal.confirm({
    title: 'Reset Password',
    content: (
      <div>
        <p style={{ marginBottom: '8px' }}>Email</p>
        <Input
          type="email"
          placeholder="Enter your email address"
          onChange={(e) => {
            emailValue = e.target.value
          }}
        />
      </div>
    ),
    okText: 'Confirm',
    cancelText: 'Cancel',
    onOk() {
      return new Promise((resolve, reject) => {
        if (!emailValue || !emailValue.includes('@')) {
          message.error('Please enter a valid email address')
          reject('Invalid email')
          return
        }

        sendResetPassword(emailValue)
          .then((result) => {
            if (result.result === 'OK') {
              message.success('Request submitted please check your email')
              resolve(true)
              return
            }
            reject('Result is not OK')
          })
          .catch((error) => {
            message.error('Request failed. Please try again.')
            reject(false)
          })
      })
    },
  })
}
